module.exports = __webpack_public_path__ + "img/thumb_09.040a9756.jpg";